const getSelector = (dataTestId: string): string => `[data-testid="${dataTestId}"]`

const DataTestId = {
  getSelector,
  bag: {
    progressWrapper: 'bag-progress-wrapper',
    progressCardNumber: 'bag-progress-card-number',
    ticketStatusCancelled: 'ticket-status-cancelled',
    ticketStatusChecked: 'ticket-status-checked',
    ticketStatusValid: 'ticket-status-valid',
    btnTap2GoModalClose: 'btn-tap2go-modal-close',
    btnQRModal: 'btn-qr-modal',
    btnDetails: 'btn-details',
    btnUseTicket: 'btn-use-ticket',
    btnMultipleSelectionMinus: 'btn-multiple-selection-minus',
    btnMultipleSelectionPlus: 'btn-multiple-selection-plus',
    btnMultipleSelectionUndo: 'btn-multiple-selection-undo',
    btnMultipleSelectionConfirm: 'btn-multiple-selection-confirm',
    itemCount: 'item-count',
    otpValue: 'otp-value',
    multipleSelection: 'multiple-selection',
    svgQRCodeModal: 'svg-modal-qr',
    bgRectangularQR: 'bg-rectangular-qr',
    canvasRectangularQR: 'canvas-rectangular-qr',
    tap2GoModal: 'tap2go-modal',
    tap2GoRecapBox: 'tap2go-recap-box',
    tap2GoSwiper: 'tap2go-swiper',
    tap2GoSwiperArrowRight: 'tap2go-swiper-arrow-right',
    tap2GoRecapElemCount: 'tap2go-recap-elem-count',
    tap2GoSuccessBox: 'tap2go-success-box',
    ticketDetailsTitle: 'ticket-details-title',
    ticketDetailsVoices: 'ticket-details-voices',
  },
  checkout: {
    btnVoucherEdit: 'btn-voucher-edit',
    btnSaveCreditCards: 'btn-save-credit-cards',
    btnStripeConfirm: 'btn-stripe-confirm',
    btnTicketAdd: 'checkout-ticket-add',
    continueBtn: 'checkout-continue-btn',
    creditCard: 'btn-credit-card',
    nexi: 'btn-nexi',
    editLabel: 'label-edit',
    recapLabel: 'label-recap',
    recapDefaultTerms: 'btn-checkout-default-terms',
    selectCreditCard: 'label-select-credit-card',
    loginBtn: 'checkout-login-btn',
    ticketQuantity: 'checkout-ticket-quantity',
  },
  header: {
    btnLogin: 'btn-login',
    btnLogged: 'btn-logged',
    btnWallet: 'btn-wallet',
  },
  event: {
    btnBuy: 'btn-buy',
  },
  form: {
    firstName: 'firstName',
    lastName: 'lastName',
    phone: 'phone',
    btnSubmit: 'submit',
  },
  login: {
    container: {
      mobile: 'login-container-mobile',
      desktop: 'login-container-desktop',
    },
    btnEmail: 'btn-login-email',
    btnPhone: 'btn-login-phone',
    btnFacebook: 'btn-login-fb',
    btnApple: 'btn-login-apple',
    btnGoogle: 'btn-login-google',
    otpCode: 'login-otp-code',
    registrationComplete: 'registration-complete',
    termsAndConditionError: 'termsAndConditions-error',
    privacyPolicyError: 'privacyPolicy-error',
    marketingPolicyError: 'marketingPolicy-error',
    profilingPolicyError: 'profilingPolicy-error',
  },
  modal: {
    btnClose: 'btn-modal-close',
  },
  profile: {
    btnLogout: 'btn-logout',
    changeNameOldTicket: 'profile-change-name-oldticket',
    changeNameNewTicketData: 'profile-change-name-newticketdata',
    changeNameSuccess: 'profile-change-name-success',
    resaleHeader: 'profile-resale-header',
    resaleModal: 'profile-resale-modal',
    resaleSuccess: 'profile-resale-success',
    transactions: 'transactions',
    transactionEventName: 'transaction-event-name',
    transactionPrice: 'transaction-price',
    transactionTicket: 'transaction-ticket',
    transactionTicketAction: 'transaction-ticket-action',
    transactionTicketChangeName: 'transaction-ticket-change-name',
    transactionTicketHolderName: 'transaction-ticket-holder-name',
    transactionTicketHolderPhone: 'transaction-ticket-holder-phone',
    transactionTicketResale: 'transaction-ticket-resale',
    transactionRefundAction: 'transaction-refund-action',
    undoResaleHeader: 'profile-undo-resale-header',
    undoResaleModal: 'profile-undo-resale-modal',
    undoResaleSuccess: 'profile-undo-resale-success',
  },
  purchaseForm: {
    btnTicketsAssign: 'btn-purchase-form-ticket-assign',
    title: 'purchase-form-title',
    eventName: 'purchase-form-event-name',
  },
  refund: {
    title: 'refund-page-title',
    form: 'refund-page-form',
    success: 'refund-success-box',
    termsAndConditions: 'termsAndConditions',
  },
  success: {
    successPurchase: 'success-purchase',
  },
  support: {
    header: 'header-help-text',
    formTestButton: 'support-form-test-button',
    successMsg: 'support-form-success-msg',
  },
  translation: {
    langSelectButton: 'lang-select-btn',
  },
  wallet: {
    btnHeaderTickets: 'btn-wallet-header-tickets',
    btnHeaderExtra: 'btn-wallet-header-extra',
    btnSeeExtra: 'btn-wallet-see-extra',
    btnSeeTickets: 'btn-wallet-see-tickets',
    btnInfoBase: 'btn-wallet-info-base',
    btnInfoDetails: 'btn-wallet-info-details',
    canvasSquareQR: 'wallet-canvas-square-qr',
    extraEventDesktop: 'wallet-extra-event-desktop',
    extraEventMobile: 'wallet-extra-event-mobile',
    regularTicketsCounterWrapper: 'wallet-regular-tickets-counter-wrapper',
    ticketsEventDesktop: 'wallet-tickets-event-desktop',
    ticketsEventMobile: 'wallet-tickets-event-mobile',
    ticketCount: 'wallet-ticket-count',
    ticketStatus: 'wallet-ticket-status',
    ticketStatusValid: 'wallet-ticket-status-valid',
    ticketDetails: 'wallet-ticket-details',
    ticketDetailsValue: 'wallet-ticket-details-value',
    userExtraDesktopContainer: 'wallet-user-extra-desktop-container',
    userExtraDesktop: 'wallet-user-extra-desktop',
    userTicketsDesktopContainer: 'wallet-user-tickets-desktop-container',
    userTicketDesktop: 'wallet-user-ticket-desktop',
  },
}

export default DataTestId
